import PageWrapper from "../components/animations/PageWrapper";
import AnimatedCard from "../components/ui/AnimatedCard";
import CardHeader from "../components/ui/CardHeader";
import CardDetails from "../components/ui/CardDetails";
import Accordion from "../components/ui/Accordion";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Competences() {
  const competencesTechniques = [
    {
      title: "Programmation",
      description: "Compétences en langages de programmation généralistes.",
      details: [
        { label: "Langages", value: "Python, Java, C, Pascal" }
      ],
    },
    {
      title: "Développement Web",
      description: "Compétences front-end et back-end pour la création de sites et d'interfaces web.",
      details: [
        { label: "Langages", value: "HTML, CSS, JavaScript" },
        { label: "Frameworks", value: "ReactJS, Node.js" }
      ],
    },
    {
      title: "Base de données",
      description: "Connaissance de systèmes de gestion de bases de données.",
      details: [
        { label: "SGBD", value: "PostgreSQL, MongoDB, Elasticsearch" }
      ],
    },
    {
      title: "Modèles de langage (LLM)",
      description: "Expérience avec outils pour LLM.",
      details: [
        { label: "Outils", value: "Ollama, LangSmith" },
        { label: "Protocole", value: "MCP" }
      ],
    },
    {
      title: "Réseau",
      description: "Notions de base sur les réseaux informatiques.",
      details: [
        { label: "Concepts", value: "Modèle OSI, TCP/IP, Routage" },
        { label: "Outils", value: "Wireshark, Postman" }
      ],
    },
  ];

  const competencesTransversales = [
    {
      title: "Langues",
      description: "Capable de parler en plusieurs langues étrangères.",
      details: [
        { label: "Anglais", value: "C1 (Certification TOEIC)" },
        { label: "Espagnol", value: "B1" }
      ],
    },
    {
      title: "Outils bureautiques",
      description: "Utilisation avancée des outils numériques et bureautiques.",
      details: [
        { label: "Certification PIX", value: "489 points" }
      ],
    },
  ];

  return (
    <main className="page-content">
      <PageWrapper>
        <section id="competences">
          <Link to="/accueil" className="back-link" aria-label="Retour à l'accueil">
            <ArrowLeft size={18} />
            <span>Accueil</span>
          </Link>
          <h2>Compétences</h2>

          <Accordion title="Techniques">
            {competencesTechniques.map((comp, i) => (
              <AnimatedCard key={i}>
                <CardHeader title={comp.title} />
                <p>{comp.description}</p>
                <CardDetails details={comp.details} />
              </AnimatedCard>
            ))}
          </Accordion>

          <Accordion title="Transversales">
            {competencesTransversales.map((comp, i) => (
              <AnimatedCard key={i}>
                <CardHeader title={comp.title} />
                <p>{comp.description}</p>
                <CardDetails details={comp.details} />
              </AnimatedCard>
            ))}
          </Accordion>
        </section>
      </PageWrapper>
    </main>
  );
}
